export default "__VITE_ASSET__DLy2Y7qp__"